<template>
  <div class="malay-financial">
    <div class="page-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{ $t('common.finance') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('financial.breadcrumb.malayAccount') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <page-nav :items="tabItems" v-model="activePageNav"></page-nav>
    <keep-alive>
      <component :is="currentPage" :table-height="tableHeight"></component>
    </keep-alive>
  </div>
</template>

<script>
import { getFinancialTabs } from '@/data/financialTabs'
import MalayRecharge from './Recharge'
import MalayExpenditure from './Expenditure'

export default {
  name: 'malayFinancial',
  data() {
    return {
      tableHeight: 0,
      activePageNav: 'recharge',
    }
  },
  computed: {
    tabItems() {
      return getFinancialTabs(this.$t.bind(this))
    },
    currentPage() {
      let page = null
      switch (this.activePageNav) {
        case 'recharge':
          page = MalayRecharge
          break
        case 'expenditure':
          page = MalayExpenditure
          break
      }
      return page
    },
  },
  mounted() {
    this.tableHeight = window.innerHeight - 365
  },
}
</script>
